import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageRoomsPage } from './manage-rooms.page';

const routes: Routes = [
  {
    path: '',
    component: ManageRoomsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageRoomsPageRoutingModule {}
